import React, { useState, useEffect, useRef, useContext } from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, TextField, Stack, Divider, LinearProgress, Avatar } from '@mui/material'
import { styled } from '@mui/system'
import workers from '../../../asset/worker_1.png'
import drill from '../../../asset/drill.png'
import factory from '../../../asset/factory.png'
import factory2 from '../../../asset/factory2.png'
import factory3 from '../../../asset/factory3.png'
import worker_2 from '../../../asset/worker_2.png'

import alram from '../../../asset/alram.png'
import { alignPropType } from 'react-bootstrap/esm/types'
import TinyBar from '../../../Graph/TinyBar'
import PieGraph from '../../../Graph/PieGraph'
import PieGraph2 from '../../../Graph/PieGraph2'
import AreaGraph from '../../../Graph/AreaGraph'
import PieGraph3 from '../../../Graph/PieGraph3'

import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'

import Api from '../../../Api/Api'

import secureLocalStorage from 'react-secure-storage'
import { useNavigate } from 'react-router-dom'

import { DataContext } from '../../../Context/LocDataContext'
import Loading from '../../../Components/Loading'
import dayjs from 'dayjs'

function useInterval(callback, delay) {
  const savedCallback = useRef()
  React.useEffect(() => {
    savedCallback.current = callback
  }, [callback])
  React.useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

const BorderLinearProgress1 = styled(LinearProgress)`
  height: 10px;
  border-radius: 5px;
  background-color: #3E3E3E;
  .MuiLinearProgress-barColorPrimary {
    background: linear-gradient(30.66deg, #62d0ff 32.8%, #e9e211 105.94%);
  }
  ,
`

const BorderLinearProgress2 = styled(LinearProgress)`
  height: 10px;
  border-radius: 5px;
  background-color: #3e3e3e;
  .MuiLinearProgress-barColorPrimary {
    background: linear-gradient(30.66deg, #62d0ff 22.8%, #0e1560 105.94%);
  }
`
const BorderLinearProgress3 = styled(LinearProgress)`
  height: 10px;
  border-radius: 5px;
  background-color: #3e3e3e;
  .MuiLinearProgress-barColorPrimary {
    background: linear-gradient(30.66deg, #62d0ff 22.8%, #b506fb 105.94%);
  }
`

const styles1 = {
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography2: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: 14,
    fontWeight: 400,
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography3: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: 32,
    fontWeight: 900,

    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Box1: {
    display: 'flex',
    justifyContent: 'center',
    alignItem: 'center',
    width: '100%',
    height: 122,
    background: '#171821',
    boxShadow: '3px 3px 4px 0px #00000099',
  },
  Box2: {
    width: '81px',
    height: '97px',
    gap: '0px',
    borderRadius: '3px',
    opacity: '0px',
    background: '#171821',
    boxShadow: '3px 3px 4px 0px #00000099',
  },

  img1: {
    width: 90,
    height: 90,
  },
  grid1: {
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    borderRadius: '10px',
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 15.98%, rgba(0, 0, 0, 0) 36.28%)',
    border: '1px solid #afafaf',
    borderImageSource:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
}

export default function MainStatsPage() {
  const navigate = useNavigate()
  const [loadingFlag, setLoadingFlag] = useState(false)
  const loginId = secureLocalStorage.getItem('loginId')
  const [item1Data, setItem1Data] = useState(0)
  const [item2Data, setItem2Data] = useState(0)
  const [item3Data, setItem3Data] = useState(0)
  const [item4Data, setItem4Data] = useState(0)
  const [item5Data, setItem5Data] = useState({})
  const [item6Data, setItem6Data] = useState([])
  const [item7Data, setItem7Data] = useState(0)
  const [item8Data, setItem8Data] = useState([])
  const [item9Data, setItem9Data] = useState(0)
  const [alramList, setAlramList] = React.useState([])
  const [alramList2, setAlramList2] = React.useState([])

  const { setInputOrgid, setInputLoid } = useContext(DataContext)

  const currentMonth = new Date().getMonth() + 1 // 현재 월 (1월은 0이므로 +1)
  const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1 // 지난달 (1월이면 12월로 설정)

  const now = dayjs().format('YYYY-MM-DD')
  const oneMonthAgo = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
  const oneDayAgo = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
  // const lastMonth = dayjs.month()
  // console.log("now:",now)
  // console.log("oneMonthAgo:",oneMonthAgo)

  //초기화면 진입시 최상단 스크롤
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const addList = () => {
    let temp = [...alramList]
    const tempLength = temp.length + 1
    const tempObject = {
      id: tempLength,
      name: `알람${tempLength}`,
      value: tempLength,
    }
    temp.unshift(tempObject)
    setAlramList(temp)
  }

  const onClickPath = (path) => {
    if (path !== '') {
      navigate(path)
    }
    // console.log('path:', path)
  }
  useEffect(() => {
    getItem1()
    getItem2()
    getItem3()
    getItem4()
    getItem5()
    getItem6()
    getItem7()
    getItem8()
    getItem9()
  }, [])
  useEffect(() => {
    getWorkerAlarm()
  }, [])

  useInterval(() => {
    getWorkerAlarm()
  }, 3000)

  function BarGraph1(param) {
    return (
      <div>
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            justifyItems: 'center',
            alignItems: 'center',
          }}
        >
          <Grid size={6} sx={{ display: 'flex', justifyItems: 'flex-start' }}>
            <Typography
              sx={[styles1.Typography2, { fontSize: 12 }]}
            >{`${param.index + 1}. ${param.param.device_type_name}`}</Typography>
          </Grid>
          <Grid size={4}>
            <BorderLinearProgress1 variant="determinate" value={param.param.occurrence_count} />
          </Grid>
          <Grid size={2}>
            <Typography
              sx={{
                fontSize: 12,
                ml: 1,
                width: '100%',
                borderRadius: 2,
                border: 1,
                color: 'rgba(252, 184, 89, 1)',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              {`${param.param.occurrence_count} %`}
            </Typography>
          </Grid>
        </Grid>
        <Grid size={12} sx={{ margin: 1 }}>
          <Divider
            sx={{
              width: '100%',
              height: 1,
              background: 'rgba(255, 255, 255, 0.06)',
            }}
          ></Divider>
        </Grid>
      </div>
    )
  }
  function BarGraph2(param) {
    return (
      <div>
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            justifyItems: 'center',
            alignItems: 'center',
          }}
        >
          <Grid size={6} sx={{ display: 'flex', justifyItems: 'flex-start' }}>
            <Typography
              sx={[styles1.Typography2, { fontSize: 12 }]}
            >{`${param.index + 1}. ${param.param.device_type_name}`}</Typography>
          </Grid>
          <Grid size={4}>
            <BorderLinearProgress2 variant="determinate" value={param.param.occurrence_count} />
          </Grid>
          <Grid size={2}>
            <Typography
              sx={{
                fontSize: 12,
                ml: 1,
                width: '100%',
                borderRadius: 2,
                border: 1,
                color: 'rgba(169, 223, 216, 1)',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              {`${param.param.occurrence_count} %`}
            </Typography>
          </Grid>
        </Grid>
        <Grid size={12} sx={{ margin: 1 }}>
          <Divider
            sx={{
              width: '100%',
              height: 1,
              background: 'rgba(255, 255, 255, 0.06)',
            }}
          ></Divider>
        </Grid>
      </div>
    )
  }
  function BarGraph3(param) {
    return (
      <div>
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            justifyItems: 'center',
            alignItems: 'center',
          }}
        >
          <Grid size={6} sx={{ display: 'flex', justifyItems: 'flex-start' }}>
            <Typography
              sx={[styles1.Typography2, { fontSize: 12 }]}
            >{`${param.index + 1}. ${param.param.device_type_name}`}</Typography>
          </Grid>
          <Grid size={4}>
            <BorderLinearProgress3 variant="determinate" value={param.param.occurrence_count} />
          </Grid>
          <Grid size={2}>
            <Typography
              sx={{
                fontSize: 12,
                ml: 1,
                width: '100%',
                borderRadius: 2,
                border: 1,
                color: 'rgba(242, 200, 237, 1)',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              {`${param.param.occurrence_count} %`}
            </Typography>
          </Grid>
        </Grid>
        <Grid size={12} sx={{ margin: 1 }}>
          <Divider
            sx={{
              width: '100%',
              height: 1,
              background: 'rgba(255, 255, 255, 0.06)',
            }}
          ></Divider>
        </Grid>
      </div>
    )
  }

  //작업인원
  const getItem1 = async () => {
    try {
      const response = await Api.get(`/api/v1/dashboard/item1?user_id=${loginId}`)
      if (response.status === 200) {
        console.log('getItem1 response.data:', response.data)
        setItem1Data(response.data)
      }
    } catch (e) {
      console.log('getItem1 exception:', e)
    }
  }
  //안전장비
  const getItem2 = async () => {
    try {
      const response = await Api.get(`/api/v1/dashboard/item2?user_id=${loginId}`)
      if (response.status === 200) {
        console.log('getItem2 response.data:', response.data)
        setItem2Data(response.data)
      }
    } catch (e) {
      console.log('getItem2 exception:', e)
    }
  }

  //관리 시설
  const getItem3 = async () => {
    try {
      const response = await Api.get(`/api/v1/dashboard/item3?user_id=${loginId}`)
      if (response.status === 200) {
        // console.log('getItem3 response.data:', response.data)
        setItem3Data(response.data)
      }
    } catch (e) {
      console.log('getItem3 exception:', e)
    }
  }
  //위험 감지
  const getItem4 = async () => {
    try {
      const response = await Api.get(`/api/v1/dashboard/item4?user_id=${loginId}`)
      if (response.status === 200) {
        // console.log('getItem4 response.data:', response.data)
        setItem4Data(response.data)
      }
    } catch (e) {
      console.log('getItem4 exception:', e)
    }
  }

  //안전장비 사용률
  const getItem5 = async () => {
    try {
      const response = await Api.get(`/api/v1/dashboard/item5?user_id=${loginId}`)
      if (response.status === 200) {
        console.log('getItem5 response.data:', response.data)

        setItem5Data(response.data)
      }
    } catch (e) {
      console.log('getItem5 exception:', e)
    }
  }

  //종류별 장비 사용량
  const getItem6 = async () => {
    try {
      const response = await Api.get(`/api/v1/dashboard/item6?user_id=${loginId}`)
      if (response.status === 200) {
        console.log('getItem6 response.data:', response.data)

        setItem6Data(response.data)
      }
    } catch (e) {
      console.log('getItem6 exception:', e)
    }
  }

  //시설별 장비 사용량
  const getItem7 = async () => {
    try {
      const response = await Api.get(`/api/v1/dashboard/item7?user_id=${loginId}`)
      if (response.status === 200) {
        console.log('getItem7 response.data:', response.data)

        setItem7Data(response.data)
      }
    } catch (e) {
      console.log('getItem7 exception:', e)
    }
  }

  //안전사고 발생량
  const getItem8 = async () => {
    try {
      const response = await Api.get(`/api/v1/dashboard/item8?user_id=${loginId}`)
      if (response.status === 200) {
        console.log('getItem8 response.data:', response.data)
        if (response.data.length == 0) {
          setItem8Data([])
        } else {
          setItem8Data(response.data)
        }
      }
    } catch (e) {
      console.log('getItem8 exception:', e)
    }
  }
  // mark
  //사고발생 추이
  const getItem9 = async () => {
    try {
      const response = await Api.get(`/api/v1/dashboard/item9`)
      if (response.status === 200) {
        console.log('getItem9 response.data:', response.data)

        setItem9Data(response.data)
      }
    } catch (e) {
      console.log('getItem9 exception:', e)
    }
  }

  //안전사고 발생알림
  const getWorkerAlarm = async () => {
    try {
      // const response = await Api.get('/api/v1/wa/')
      const response = await Api.get('/api/v1/wa/get/yesterday')

      if (response.status === 200) {
        console.log('getWorkerAlarm response.data:', response.data)
        if (response.data.length == 0) {
          setAlramList2([])
        } else {
          setAlramList2(response.data)
        }
      }
    } catch (e) {
      setLoadingFlag(false)
      console.log('getWorkerAlarm exception:', e)
    }
  }

  //안전사고 발생량
  const patchWorkerAlarmCK = async (param) => {
    // console.log("postWorkerAlarmCK param:", param)
    try {
      const response = await Api.patch(`/api/v1/wa/${param}`)
      if (response.status === 200) {
        console.log('postWorkerAlarmCK ok')
      }
    } catch (e) {
      console.log('postWorkerAlarmCK exception:', e)
    }
  }

  // 페이지 이동 함수
  const handleButtonClick = (aid, orgid, loid) => {
    console.log('handleButtonClick aid, orgid, loid:', aid, orgid, loid)
    patchWorkerAlarmCK(aid)
    setInputOrgid(orgid)
    setInputLoid(loid)
    navigate('/User/DashBoard/SceneStats') // 이동할 페이지 경로
  }

  return (
    <div style={{ marginBottom: 100 }}>
      <Grid container sx={{ m: 7 }} spacing={4}>
        <Grid size={8} sx={{ mt: 3 }}>
          <Grid container spacing={3}>
            <Grid size={12} sx={styles1.grid1}>
              <div style={{ padding: 20 }}>
                <Typography sx={[styles1.Typography1, { fontSize: '22px', fontWeight: 900 }]}>
                  실시간 주요 현황
                </Typography>
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid size={3}>
                    <Box sx={styles1.Box1}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          padding: 3,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Stack>
                          <Typography sx={styles1.Typography2}>작업 인원</Typography>
                          <Typography sx={styles1.Typography3}>{item1Data.worker_cnt}</Typography>
                        </Stack>
                        <Box>
                          <img style={styles1.img1} src={workers}></img>
                        </Box>
                      </Stack>
                    </Box>
                  </Grid>
                  <Grid size={3}>
                    <Box sx={styles1.Box1}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          padding: 3,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Stack>
                          <Typography sx={styles1.Typography2}>안전 장비</Typography>
                          <Typography sx={styles1.Typography3}>{item2Data.device_cnt}</Typography>
                        </Stack>
                        <Box>
                          <img style={styles1.img1} src={drill}></img>
                        </Box>
                      </Stack>
                    </Box>
                  </Grid>
                  <Grid size={3}>
                    <Box sx={styles1.Box1}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          padding: 3,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Stack>
                          <Typography sx={styles1.Typography2}>관리 시설</Typography>
                          <Typography sx={styles1.Typography3}>{item3Data.location_cnt}</Typography>
                        </Stack>
                        <Box>
                          <img style={styles1.img1} src={factory}></img>
                        </Box>
                      </Stack>
                    </Box>
                  </Grid>
                  <Grid size={3}>
                    <Box sx={styles1.Box1}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          padding: 3,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Stack>
                          <Typography sx={styles1.Typography2}>위험 감지</Typography>
                          <Typography sx={styles1.Typography3}>{item4Data.warning_cnt}</Typography>
                        </Stack>
                        <Box>
                          <img style={styles1.img1} src={alram}></img>
                        </Box>
                      </Stack>
                    </Box>
                  </Grid>
                </Grid>
              </div>
            </Grid>

            <Grid size={12} sx={[styles1.grid1, { padding: 2.5 }]}>
              <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={[styles1.Typography1, { fontSize: '22px', fontWeight: 900 }]}>월간통계</Typography>
                <Typography
                  sx={[
                    styles1.Typography1,
                    {
                      color: '#b1b1b1',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      fontSize: 17,
                      fontWeight: 100,
                    },
                  ]}
                >
                  {`(기준 :${oneMonthAgo} ~ ${now})`}
                </Typography>
              </Stack>

              <Grid container spacing={3}>
                <Grid size={12}>
                  <Grid container>
                    <Grid size={12}>
                      <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Grid size={3.7}>
                          <div style={{ padding: 20 }}>
                            <Typography sx={styles1.Typography1}>안전장비 사용률</Typography>
                            <Typography sx={[styles1.Typography1, { fontSize: 12, fontWeight: 300 }]}>
                              {'(스마트안전모,가스검침기)'}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: 14,
                                fontWeight: 500,
                                justifyContent: 'center',
                                justifyItems: 'center',
                                display: 'flex',
                                backgroundcolor: 'primary',
                                backgroundImage: `linear-gradient(1.26deg, #628EFF -0.09%, #8740CD 101.94%, #8740CD 191.97%)`,
                                backgroundSize: '100%',
                                backgroundRepeat: 'repeat',
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                              }}
                            >
                              {`Total:${item5Data.total_device_cnt} Use:${item5Data.device_cnt}`}
                            </Typography>
                            <PieGraph param={item5Data} />
                            <Typography
                              sx={{
                                fontFamily: 'Inter',
                                fontSize: '22px',
                                fontWeight: 700,
                                color: '#ffffff',
                                marginTop: -15,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              {`${Math.floor((item5Data.device_cnt / item5Data.total_device_cnt) * 100)}%`}
                            </Typography>
                          </div>
                        </Grid>
                        <Grid
                          size={0.1}
                          sx={{
                            marginTop: 4,
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          <Divider
                            sx={{
                              width: '1px',
                              height: '90%',
                              background: 'rgba(255, 255, 255, 0.06)',
                            }}
                            orientation="horizontal"
                            flexItem
                          />
                        </Grid>
                        <Grid size={4.1}>
                          <div style={{ padding: 20 }}>
                            <Typography sx={styles1.Typography1}>종류별 장비 사용량</Typography>

                            <Grid size={12} sx={{ margin: 1 }}>
                              <Divider
                                sx={{
                                  width: '100%',
                                  height: 1,
                                  background: 'rgba(255, 255, 255, 0.06)',
                                }}
                              ></Divider>
                            </Grid>
                            <Grid size={12}>
                              <Grid container>
                                <Grid size={12}>
                                  {' '}
                                  {item6Data && item6Data.device_using_dict !== undefined ? (
                                    item6Data.device_using_dict.length === 0 ? (
                                      <div>
                                        <text
                                          style={{
                                            color: '#fefae0',
                                            fontFamily: 'Montserrat',
                                            fontSize: '12px',
                                          }}
                                        >
                                          종류별 장비 사용량 데이터가 없습니다
                                        </text>
                                      </div>
                                    ) : (
                                      item6Data.device_using_dict.map((item, index) => (
                                        <div key={index}>
                                          {index === 0 || index % 3 === 0 ? (
                                            <BarGraph1 param={item} index={index} />
                                          ) : index === 1 || index % 3 === 1 ? (
                                            <BarGraph2 param={item} index={index} />
                                          ) : index === 2 || index % 3 === 2 ? (
                                            <BarGraph3 param={item} index={index} />
                                          ) : null}
                                        </div>
                                      ))
                                    )
                                  ) : null}
                                </Grid>
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                        <Grid
                          size={0.1}
                          sx={{
                            marginTop: 4,
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          <Divider
                            sx={{
                              width: '1px',
                              height: '90%',
                              background: 'rgba(255, 255, 255, 0.06)',
                            }}
                            orientation="horizontal"
                            flexItem
                          />
                        </Grid>
                        <Grid size={3.9}>
                          <div style={{ padding: 20 }}>
                            <Typography sx={styles1.Typography1}>시설별 장비 사용량</Typography>
                            <Grid size={12} sx={{ margin: 1 }}>
                              <Divider
                                sx={{
                                  width: '100%',
                                  height: 1,
                                  background: 'rgba(255, 255, 255, 0.06)',
                                }}
                              ></Divider>
                            </Grid>

                            <Grid container>
                              <Grid size={12}>
                                {item7Data && item7Data.location_device_dict !== undefined ? (
                                  item7Data.location_device_dict.length === 0 ? (
                                    <text
                                      style={{
                                        color: '#fefae0',
                                        fontFamily: 'Montserrat',
                                        fontSize: '12px',
                                      }}
                                    >
                                      시설별 장비 사용량 데이터가 없습니다
                                    </text>
                                  ) : (
                                    item7Data.location_device_dict.map((item, index) => (
                                      <div key={index}>
                                        <div>
                                          <Grid
                                            container
                                            sx={{
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignContent: 'center',
                                              justifyItems: 'center',
                                              alignItems: 'center',
                                            }}
                                          >
                                            <Grid
                                              size={6}
                                              sx={{
                                                display: 'flex',
                                                justifyItems: 'flex-start',
                                              }}
                                            >
                                              <Typography sx={[styles1.Typography2, { fontSize: 12 }]}>
                                                {`${index + 1}. ${item.lon}`}
                                              </Typography>
                                            </Grid>
                                            <Grid size={4}>
                                              {index === 0 || index % 3 === 0 ? (
                                                <BorderLinearProgress1
                                                  variant="determinate"
                                                  value={item.occurrence_count}
                                                />
                                              ) : index === 1 || index % 3 === 1 ? (
                                                <BorderLinearProgress2
                                                  variant="determinate"
                                                  value={item.occurrence_count}
                                                />
                                              ) : index === 2 || index % 3 === 2 ? (
                                                <BorderLinearProgress3
                                                  variant="determinate"
                                                  value={item.occurrence_count}
                                                />
                                              ) : (
                                                ''
                                              )}
                                            </Grid>
                                            <Grid size={2}>
                                              <Typography
                                                sx={{
                                                  fontSize: 12,
                                                  ml: 1,
                                                  width: '100%',
                                                  borderRadius: 2,
                                                  border: 1,
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  display: 'flex',
                                                  color:
                                                    index === 0 || index % 3 === 0
                                                      ? 'rgba(252, 184, 89, 1)'
                                                      : index === 1 || index % 3 === 1
                                                        ? 'rgba(169, 223, 216, 1)'
                                                        : index === 2 || index % 3 === 2
                                                          ? 'rgba(242, 200, 237, 1)'
                                                          : '',
                                                }}
                                              >
                                                {`${item.occurrence_count} %`}
                                              </Typography>
                                            </Grid>
                                          </Grid>

                                          <Grid size={12} sx={{ margin: 1 }}>
                                            <Divider
                                              sx={{
                                                width: '100%',
                                                height: 1,
                                                background: 'rgba(255, 255, 255, 0.06)',
                                              }}
                                            ></Divider>
                                          </Grid>
                                        </div>
                                      </div>
                                    ))
                                  )
                                ) : (
                                  '데이터없음'
                                )}
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                      </Grid>
                      <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Grid size={3.7}>
                          <div style={{ padding: 20 }}>
                            <Typography sx={styles1.Typography1}>안전사고 발생량</Typography>
                            <Grid container>
                              {item8Data !== undefined &&
                              item8Data !== null &&
                              item8Data !== '' &&
                              item8Data.total_warning_dict !== undefined &&
                              item8Data.total_warning_dict.length > 0 ? (
                                <>
                                  <Grid size={8}>
                                    <PieGraph2 param={item8Data} />
                                  </Grid>
                                  <Grid size={4} sx={{ marginTop: 2 }}>
                                    <Stack direction="row" spacing={1} marginTop={1}>
                                      <div
                                        style={{
                                          marginTop: 5,
                                          borderRadius: '50%',
                                          height: 12,
                                          width: 12,
                                          background:
                                            'linear-gradient(89.58deg, #bababa 10%, #8740CD 57.32%, #580475 99.08%)',
                                        }}
                                      ></div>
                                      <Typography sx={styles1.Typography2}>부딪힘</Typography>
                                    </Stack>

                                    <Stack direction="row" spacing={1} marginTop={1}>
                                      <div
                                        style={{
                                          marginTop: 5,
                                          borderRadius: '50%',
                                          height: 12,
                                          width: 12,
                                          background:
                                            'linear-gradient(89.58deg, #C4E6EA 10%, #139FAF 57.32%, #0E7783 99.08%)',
                                        }}
                                      ></div>
                                      <Typography sx={styles1.Typography2}>쓰러짐</Typography>
                                    </Stack>

                                    <Stack direction="row" spacing={1} marginTop={1}>
                                      <div
                                        style={{
                                          marginTop: 5,
                                          borderRadius: '50%',
                                          height: 12,
                                          width: 12,
                                          background:
                                            'linear-gradient(89.58deg, #C8D2F7 10%, #224CE3 57.32%, #1939AA 99.08%)',
                                        }}
                                      ></div>
                                      <Typography sx={styles1.Typography2}>낙상</Typography>
                                    </Stack>

                                    {/* <Stack direction="row" spacing={1}>
                            <div
                              style={{
                                marginTop: 5,
                                borderRadius: '50%',
                                height: 12,
                                width: 12,
                                background: 'linear-gradient(89.58deg, #071b6d 10%, #0F37DB 57.32%, #f0f0f0 99.08%)',
                              }}
                            ></div>
                            <Typography sx={styles1.Typography2}>낙상</Typography>
                          </Stack> */}
                                  </Grid>
                                </>
                              ) : (
                                <>
                                  <Grid size={8}>
                                    <PieGraph3 />
                                  </Grid>
                                  <Grid size={4} sx={{ marginTop: 2 }}>
                                    <Stack direction="row" spacing={1} marginTop={1}>
                                      <div
                                        style={{
                                          marginTop: 5,
                                          borderRadius: '50%',
                                          height: 12,
                                          width: 12,
                                          background:
                                            'linear-gradient(89.58deg, #000000 10%, #000000 57.32%, #000000 99.08%)',
                                        }}
                                      ></div>
                                      <Typography sx={styles1.Typography2}>데이터 없음</Typography>
                                    </Stack>
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          </div>
                        </Grid>
                        <Grid
                          size={0.1}
                          sx={{
                            marginTop: 4,
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          <Divider
                            sx={{
                              width: '1px',
                              height: '90%',
                              background: 'rgba(255, 255, 255, 0.06)',
                            }}
                            orientation="horizontal"
                            flexItem
                          />
                        </Grid>
                        <Grid size={4.1}>
                          <div style={{ padding: 20 }}>
                            {/* mark */}
                            <Typography sx={styles1.Typography1}>사고발생 추이</Typography>
                            <Typography
                              sx={[
                                styles1.Typography1,
                                {
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  fontSize: 11,
                                  fontWeight: 100,
                                },
                              ]}
                            >
                              {/* {'기준 : 11.01 ~ 11.30  (1 Month)'} */}
                            </Typography>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginLeft: 15,
                              }}
                            >
                              <AreaGraph param={item9Data} />
                            </div>

                            <Grid
                              size={12}
                              sx={{
                                marginTop: 2,
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              <Stack
                                direction="row"
                                divider={<Divider sx={{ background: '#777777' }} orientation="vertical" flexItem />}
                                spacing={2}
                              >
                                <Stack direction="row" spacing={2}>
                                  <div
                                    style={{
                                      marginTop: 2,
                                      borderRadius: '50%',
                                      height: 12,
                                      width: 12,
                                      background: '#A9DFD8',
                                    }}
                                  ></div>
                                  <Typography
                                    sx={[
                                      styles1.Typography2,
                                      {
                                        fontFamily: 'Inter',
                                        fontSize: 12,
                                        color: '#A0A0A0',
                                      },
                                    ]}
                                  >
                                    {`지난달(${previousMonth}월)`}
                                  </Typography>
                                </Stack>
                                <Stack direction="row" spacing={2}>
                                  <div
                                    style={{
                                      marginTop: 2,
                                      borderRadius: '50%',
                                      height: 12,
                                      width: 12,
                                      background: '#F2C8ED',
                                    }}
                                  ></div>
                                  <Typography
                                    sx={[
                                      styles1.Typography2,
                                      {
                                        fontFamily: 'Inter',
                                        fontSize: 12,
                                        color: '#A0A0A0',
                                      },
                                    ]}
                                  >
                                    {`이번달(${currentMonth}월)`}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Grid>
                          </div>
                        </Grid>
                        <Grid
                          size={0.1}
                          sx={{
                            marginTop: 4,
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          <Divider
                            sx={{
                              width: '1px',
                              height: '90%',
                              background: 'rgba(255, 255, 255, 0.06)',
                            }}
                            orientation="horizontal"
                            flexItem
                          />
                        </Grid>
                        <Grid size={3.9}>
                          <div style={{ padding: 20 }}>
                            <Stack direction="row" spacing={1}>
                              <Typography sx={styles1.Typography1}>현장 모니터링 바로가기</Typography>
                              <Typography
                                sx={{
                                  display: 'flex',
                                  justifyItems: 'center',
                                  alignItems: 'center',
                                  fontSize: 12,
                                  color: '#A2A2A8',
                                  fontFamily: 'Noto Sans KR',
                                  fontWeight: 400,
                                  textUnderlinePosition: 'from-font',
                                  textDecorationSkipInk: 'none',
                                }}
                                onClick={() => onClickPath('/User/DashBoard/SceneStats')}
                              >{`More`}</Typography>
                            </Stack>

                            <Grid container spacing={2} sx={{ marginTop: 4 }}>
                              <Grid size={4}>
                                <Box sx={styles1.Box2} onClick={() => onClickPath('/User/DashBoard/SceneStats')}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <img
                                      style={{
                                        height: 62,
                                        width: 62,
                                        marginTop: 5,
                                      }}
                                      src={factory}
                                    />
                                    <Typography sx={[styles1.Typography2, { marginTop: 0.9 }]}>탈수기동</Typography>
                                  </div>
                                </Box>
                              </Grid>
                              <Grid size={4}>
                                <Box sx={styles1.Box2} onClick={() => onClickPath('/User/DashBoard/SceneStats')}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <img
                                      style={{
                                        height: 62,
                                        width: 62,
                                        marginTop: 5,
                                      }}
                                      src={factory2}
                                    ></img>
                                    <Typography sx={[styles1.Typography2, { marginTop: 0.7 }]}>배수기동</Typography>
                                  </div>
                                </Box>
                              </Grid>
                              <Grid size={4}>
                                <Box sx={styles1.Box2} onClick={() => onClickPath('/User/DashBoard/SceneStats')}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <img
                                      style={{
                                        height: 62,
                                        width: 62,
                                        marginTop: 5,
                                      }}
                                      src={factory3}
                                    ></img>
                                    <Typography sx={[styles1.Typography2, { marginTop: 0.9 }]}>중앙 관리동</Typography>
                                  </div>
                                </Box>
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={4} sx={[styles1.grid1, { mt: 2.8 }]}>
          <div style={{ padding: 20 }}>
            <Typography
              sx={[
                styles1.Typography1,
                { fontSize: 15, color: '#b1b1b1', display: 'flex', justifyContent: 'flex-end' },
              ]}
              onClick={() => {
                navigate('/User/SysManage/LogManage')
              }}
            >
              {'More >'}
            </Typography>
            <Typography sx={[styles1.Typography1, { fontSize: '22px', fontWeight: 900 }]}>안전사고 발생알림</Typography>
            <Typography
              sx={[styles1.Typography1, { fontSize: 15, color: '#b1b1b1' }]}
            >{`(전일기준:${oneDayAgo}~${now})`}</Typography>

            {/* <Button variant="contained" onClick={() => addList()}>
                  리스트 추가
                </Button> */}
            <List sx={{ maxHeight: 660, overflow: 'auto' }}>
              {alramList2.length === 0 ? (
                <Typography sx={{ textAlign: 'center', marginTop: 10 }}>
                  <text
                    style={{
                      color: '#fefae0',
                      fontFamily: 'Montserrat',
                      fontSize: '12px',
                    }}
                  >
                    안전사고 발생알림이 없습니다
                  </text>
                </Typography>
              ) : (
                alramList2.map((item, index) => {
                  return (
                    <ListItem key={index}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginTop: 10,
                        }}
                      >
                        <Grid container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Stack
                              direction="row"
                              spacing={2}
                              sx={{
                                width: 210,
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <Avatar src={worker_2} />
                              <Stack>
                                <Typography
                                  sx={{
                                    color: '#ffffff',
                                    fontFamily: 'Montserrat',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    lineHeight: '20.4px',
                                    textAlign: 'left',
                                    textUnderlinePosition: 'from-font',
                                    textDecorationSkipInk: 'none',
                                  }}
                                >
                                  {item.wname}
                                </Typography>
                                <Typography
                                  sx={{
                                    color: '#7F7F7F',
                                    fontFamily: 'Montserrat',
                                    fontSize: '10px',
                                    fontWeight: 400,
                                    lineHeight: '20.4px',
                                    textAlign: 'left',
                                    textUnderlinePosition: 'from-font',
                                    textDecorationSkipInk: 'none',
                                  }}
                                >
                                  {item.accident_type}
                                </Typography>
                              </Stack>
                              <Button
                                variant="contained"
                                sx={{
                                  fontSize: 10,
                                  background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                  width: '81px',
                                  height: '30px',
                                  borderRadius: '6px',
                                }}
                                onClick={() => handleButtonClick(item.aid, item.orgid, item.loid)}
                              >
                                현장 위치
                              </Button>
                            </Stack>
                          </Grid>
                        </Grid>
                      </div>
                    </ListItem>
                  )
                })
              )}
            </List>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}
